import { apiPost, apiStore } from '../../../modules/apiHelper';
import { toBoolean } from '../../../modules/dataHelper';

export default {
  /**
   * Liases with the api
   * @param {Object} context
   * @param {Array} newGoals
   */
  async updateMentorGoals(context, newGoals = []) {
    const removeGoalsPromises = [];
    const addGoalsPromises = [];
    // eslint-disable-next-line no-var
    var hasErrors = false;
    console.log(newGoals);

    // removing unselected goals
    context.state.goals.forEach((goalid) => {
      const mentorGoalExists = newGoals.find(newGoalid => newGoalid === goalid);
      console.log('remove mentor goal? ', !mentorGoalExists, goalid);

      if (!mentorGoalExists) {
        const formData = new FormData();
        formData.set('goalid', goalid);
        formData.set('userid', context.rootState.User.id);
        // apiPost
        const promise = apiPost('del_ment_goal', formData, 1)
          .catch((err) => {
            hasErrors = true;
            console.warn('Cannot remove goal ', goalid, '\n', err);
          })
          .then((res) => {
            if (!res) return false;
            if (toBoolean(res.data.error)) {
              hasErrors = true;
              console.warn('Error in removing goal \n', res.data.message);
              return false;
            }

            context.commit('removeMentorGoal', goalid);
            return true;
          });

        removeGoalsPromises.push(promise);
      }
    });

    await Promise.all(removeGoalsPromises);

    // adding selected goal
    newGoals.forEach((goalid) => {
      const mentorGoalExists = context.getters.getMentorGoal(goalid);
      console.log('add mentor goal? ', !mentorGoalExists, goalid);

      if (!mentorGoalExists) {
        const formData = new FormData();
        formData.set('goalid', goalid);
        formData.set('userid', context.rootState.User.id);
        // [TODO] Dynamic goal type by license
        formData.set('type', 1);
        const promise = apiPost('add_mentor_goal', formData, 1)
          .catch((err) => {
            hasErrors = true;
            console.warn('Could not create mentor goal \n', err);
          })
          .then((res) => {
            if (!res) return false;
            if (toBoolean(res.data.error)) {
              hasErrors = true;
              console.warn('Error in adding mentor goal \n', res.data.message);
              return false;
            }

            context.commit('addMentorGoal', goalid);
            return true;
          });

        addGoalsPromises.push(promise);
      }
    });

    const addGoalsResponse = await Promise.all(addGoalsPromises)
      .then(async () => {
        if (hasErrors) {
          await context.dispatch('getUserGoals')
            .then((res) => {
              if (!res) return false;
              if (toBoolean(res.data.error)) {
                return false;
              }

              const userGoals = res.data.goals_check || [];

              userGoals.forEach((goal) => {
                context.commit('addMentorGoal', goal.ementid);
              });

              return true;
            });
        }
        await apiStore.setItem('mentorgoals', context.state.goals);
      });

    return addGoalsResponse;
  },
  async getMenteeGoals(context, [menteeId, humanizeData = false]) {
    const mentee = await context.dispatch('getUserData', menteeId);
    const formData = new FormData();
    formData.set('userid', menteeId);

    return apiPost('sub_goals_check', formData, 1)
      .catch((err) => {
        console.warn('Error in getting sub goals check. \n', err);
        return [];
      })
      .then(async (res) => {
        if (!res) return [];
        if (res.data.error) {
          console.warn('Error in getting sub goals check. \n', res.data.message);
          return [];
        }

        if (!humanizeData) {
          return res.data.goals_check || [];
        }

        const goals = [];
        const companyGoals = await context.dispatch('getGoals', [mentee.companyid]);

        if (!companyGoals) {
          return [];
        }

        res.data.goals_check.forEach((goal) => {
          const goalFound = companyGoals.find(g => g.id === goal.ementid);

          if (goalFound) {
            goals.push(goalFound);
          }
        });

        return goals;
      });
  },
};
